import { APP_INITIALIZER, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MsalGuard } from '@azure/msal-angular';
import { of } from 'rxjs';
//import {
// ProtectedResourceScopes,
// MsalInterceptorConfiguration,
// MSAL_GUARD_CONFIG,
// MSAL_INSTANCE,
// MsalBroadcastService,
// MsalGuard,
// MsalGuardConfiguration,
// MsalRedirectComponent,
//MsalService,
// MsalModule,
// MSAL_INTERCEPTOR_CONFIG,
// MsalInterceptor,
//} from '@azure/msal-angular';
import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
} from '@azure/msal-browser';
//import { msalConfig, protectedResources } from 'src/app/auth.config';
import { environment } from 'src/app/environments/environment';
import { getClaimsFromStorage } from 'src/app/storage-utils';
import { CommonInterceptor } from './common/_helpers/common.interceptor';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LandingPageComponent } from './modules/landing-page/landing-page.component';
import { HeaderLandingpageComponent } from './common/header/header-landingpage/header-landingpage.component';
import { SharedModule } from './common/shared/shared.module';
import { ProjectManagementModule } from './modules/project-management/project-management.module';
import { UserManagementModule } from './modules/user-management/user-management.module';
import { ReportManagementComponent } from './modules/report-management/report-management.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { DataUploadComponent } from './modules/data-upload/data-upload.component';
import { DocumentclickDirective } from './common/directives/documentclick.directive';
import { HeaderUploadModuleComponent } from './common/header/header-upload-module/header-upload-module.component';
import { HeaderNavSnapOutputComponent } from './common/header/header-nav-snap-output/header-nav-snap-output.component';
import { HeaderSectionListComponent } from './common/header/header-section-list/header-section-list.component';

import { ChatbotComponent } from './modules/chatbot/chatbot.component';
import { ChatbotexpandComponent } from './modules/chatbotexpand/chatbotexpand.component';
import { RestatementComponent } from './modules/data-upload/restatement/restatement.component';
import { NewLandingPageComponent } from './modules/aesthetics/new-landing-page/new-landing-page.component';
import { SnapshotLandingContainerComponent } from './common/shared/snapshot-landing-container/snapshot-landing-container.component';
import { ModuleLandingComponent } from './core/components/module-landing/module-landing.component';

import { SnapshotModule } from './modules/snapshot/snapshot.module';
import { ModuleTileLandingComponent } from './core/components/module-tile-landing/module-tile-landing.component';
import { LoginComponent } from './modules/login/login.component';
import { ExternalSSOComponent } from './modules/external-sso/external-sso.component';
import { dedicatedThemeAppInitializerFactory } from './initializers/dedicated-theme.loader';
import { ClientssoService } from './common/services/clientsso.service';
import { ClientcallbackComponent } from './modules/clientcallback/clientcallback.component';
import { KantarssocallbackComponent } from './modules/kantarssocallback/kantarssocallback.component';

// import { HeaderNavTextSnapshotComponent } from './common/header/header-nav-text-snapshot/header-nav-text-snapshot.component';
// export function MSALInstanceFactory(): IPublicClientApplication {
//   return new PublicClientApplication(msalConfig);
// }

// export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
//   const protectedResourceMap = new Map<
//     string,
//     Array<string | ProtectedResourceScopes> | null
//   >();

//   const oktaBase = new URL('api/auth/okta/', environment.baseApiUrl).toString();
//   protectedResourceMap.set(oktaBase, null);

//   protectedResourceMap.set(protectedResources.Api.endpoint, [
//     {
//       httpMethod: 'GET',
//       scopes: [...protectedResources.Api.scopes.read],
//     },
//     {
//       httpMethod: 'POST',
//       scopes: [...protectedResources.Api.scopes.read],
//     },
//     {
//       httpMethod: 'DELETE',
//       scopes: [...protectedResources.Api.scopes.read],
//     },
//     {
//       httpMethod: 'PATCH',
//       scopes: [...protectedResources.Api.scopes.read],
//     },
//     {
//       httpMethod: 'PUT',
//       scopes: [...protectedResources.Api.scopes.read],
//     },
//   ]);

//   return {
//     interactionType: InteractionType.Redirect,
//     protectedResourceMap,
//     authRequest: (msalService, httpReq, originalAuthRequest) => {
//       const resource = new URL(httpReq.url).hostname;
//       let claim =
//         msalService.instance.getActiveAccount()! &&
//         getClaimsFromStorage(
//           `cc.${msalConfig.auth.clientId}.${
//             msalService.instance.getActiveAccount()?.idTokenClaims?.oid
//           }.${resource}`,
//         )
//           ? window.atob(
//               getClaimsFromStorage(
//                 `cc.${msalConfig.auth.clientId}.${
//                   msalService.instance.getActiveAccount()?.idTokenClaims?.oid
//                 }.${resource}`,
//               ),
//             )
//           : undefined;

//       return {
//         ...originalAuthRequest,
//         claims: claim,
//         authority: `https://login.microsoftonline.com/${originalAuthRequest.account?.tenantId ?? '1e355c04-e0a4-42ed-8e2d-7351591f0ef1'}`,
//       };
//     },
//   };
// }

/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */

// export function MSALGuardConfigFactory(): MsalGuardConfiguration {
//   return {
//     interactionType: InteractionType.Redirect,
//   };
// }

// Stub MsalGuard that always allows navigation — MSAL is no longer used
// for auth (replaced by ClientssoService) but several routing modules still
// reference MsalGuard in canActivate. Providing this stub globally avoids
// having to edit every routing module.
class MsalGuardStub {
  canActivate() { return of(true); }
  canActivateChild() { return of(true); }
  canMatch() { return of(true); }
}

@NgModule({
  declarations: [
    DocumentclickDirective,
    AppComponent,
    LandingPageComponent,
    HeaderLandingpageComponent,
    ReportManagementComponent,
    DataUploadComponent,
    HeaderUploadModuleComponent,
    RestatementComponent,
    ChatbotComponent,
    ChatbotexpandComponent,
    NewLandingPageComponent,
    SnapshotLandingContainerComponent,
    ModuleLandingComponent,
    ModuleTileLandingComponent,
    LoginComponent,
    ExternalSSOComponent,
    ClientcallbackComponent,
    KantarssocallbackComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ProjectManagementModule,
    UserManagementModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ScrollingModule,
    SnapshotModule,
    NgIdleKeepaliveModule.forRoot(),
    // MsalModule.forRoot(
    //   new PublicClientApplication(msalConfig),
    //   {
    //     interactionType: InteractionType.Redirect,
    //     authRequest: { scopes: ['user.read'] },
    //   },
    //   {
    //     interactionType: InteractionType.Redirect,
    //     protectedResourceMap: new Map([
    //       [environment.baseApiUrl, ['user.read']],
    //     ]),
    //   },
    // ),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: dedicatedThemeAppInitializerFactory,
      multi: true,
    },
    ClientssoService,
    { provide: MsalGuard, useClass: MsalGuardStub },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CommonInterceptor,
      multi: true,
    },
  ],

  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {}
